import { createInstance } from 'localforage'

const ReferenceDataLocalForage = createInstance({
  name: 'CattleTickReferenceDataStore',
  storeName: 'CATTLETICK_REF_DATA_V1',
  description: 'Store of reference data',
})

export async function emptyStore() {
  await ReferenceDataLocalForage.clear()
}

export async function updateStore(referenceData: ReferenceData[]) {
  await ReferenceDataLocalForage.clear()
  for (const data of referenceData) {
    await ReferenceDataLocalForage.setItem(data.type, data)
  }
}

export async function getReferenceDataByType(
  typeKey: string,
): Promise<ReferenceData | null> {
  return await ReferenceDataLocalForage.getItem(typeKey)
}

export async function getAllReferenceData() {
  const referenceData: ReferenceData[] = []
  await ReferenceDataLocalForage.iterate((record: ReferenceData) => {
    referenceData.push(record)
  })
  return referenceData
}

export async function getAllReferenceDataMeta() {
  const referenceDataMeta: Record<string, string> = {}
  await ReferenceDataLocalForage.iterate((record: ReferenceData) => {
    if (record) {
      referenceDataMeta[record.type] = record.hash
    }
  })
  return referenceDataMeta
}
